
import React from 'react';

const BenefitsSection = () => {
  const benefits = [
    {
      icon: 'ri-heart-pulse-line',
      title: 'Enhanced Recovery',
      description: 'Accelerate healing from workouts, injuries, and daily stress with targeted recovery peptides.'
    },
    {
      icon: 'ri-brain-line',
      title: 'Cognitive Enhancement',
      description: 'Improve memory, focus, and mental clarity with nootropic peptide protocols.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Immune Support',
      description: 'Strengthen your immune system and enhance resistance to illness and infection.'
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Increased Energy',
      description: 'Boost cellular energy production and combat fatigue with metabolic peptides.'
    },
    {
      icon: 'ri-muscle-line',
      title: 'Muscle Growth',
      description: 'Optimize muscle protein synthesis and enhance lean body mass development.'
    },
    {
      icon: 'ri-time-line',
      title: 'Anti-Aging Effects',
      description: 'Slow cellular aging processes and promote longevity with regenerative peptides.'
    },
    {
      icon: 'ri-scales-line',
      title: 'Weight Management',
      description: 'Support healthy weight loss and metabolic optimization with targeted peptides.'
    },
    {
      icon: 'ri-moon-line',
      title: 'Better Sleep Quality',
      description: 'Improve sleep depth and recovery with growth hormone releasing peptides.'
    }
  ];

  return (
    <section className="py-16 lg:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 lg:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 lg:mb-6">
            Transform Your Health with <strong>Peptide Therapy</strong>
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Experience the powerful benefits of peptide therapy as your body optimizes its natural healing and performance capabilities.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {benefits.map((benefit, index) => (
            <div key={index} className="bg-gray-50 rounded-2xl p-6 lg:p-8 text-center hover:shadow-lg transition-shadow duration-300">
              <div className="w-16 h-16 bg-gradient-to-r from-blue-600 to-blue-700 rounded-2xl flex items-center justify-center mx-auto mb-4 lg:mb-6">
                <i className={`${benefit.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-lg lg:text-xl font-bold text-gray-900 mb-3">
                {benefit.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-12 lg:mt-16 text-center">
          <div className="bg-gradient-to-r from-blue-600 to-blue-700 rounded-2xl p-8 lg:p-12 text-white">
            <h3 className="text-2xl lg:text-3xl font-bold mb-4 lg:mb-6">
              Ready to Experience Peptide Therapy?
            </h3>
            <p className="text-lg lg:text-xl mb-6 lg:mb-8 opacity-90 max-w-2xl mx-auto">
              Join thousands of patients who have transformed their health with our cutting-edge peptide protocols.
            </p>
            <button className="bg-white text-blue-600 px-8 py-4 rounded-xl font-semibold hover:shadow-lg transform hover:-translate-y-1 transition-all duration-300 whitespace-nowrap cursor-pointer">
              Schedule Consultation
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
